import { CallableRequest, CallableResponse } from 'firebase-functions/v2/https';
import { Languages } from '../languages';

export const FOLLOWUP_MAX_TURNS = 30;

/** High–level phases so UI can show spinners */
export type ChunkType = 'text' | 'citation' | 'searching' | 'reasoning';

export interface BaseChunk {
    type: ChunkType;
}

export interface TextChunk extends BaseChunk {
    token: string;
    type: 'text';
}

export interface CitationChunk extends BaseChunk {
    charOffset: number;
    fileId: string;
    refNumber: number;
    type: 'citation';
}

export interface PhaseChunk extends BaseChunk {
    type: 'searching' | 'reasoning';
}

export interface AiSearchRequest {
    isCopilot: boolean;
    language: Languages;
    query: string;
    /* Optional id of an existing AiSearchData document to continue as a follow-up */
    responseId?: string;
}

export type AiSearchStream = TextChunk | CitationChunk | PhaseChunk;

export interface AiSearchResponse {
    citations: CitationChunk[];
    fileSlug: string;
    language: Languages;
    markdown: string;
    responseId: string;
}

export type AiSearchBooksFunc = (
    request: CallableRequest<AiSearchRequest>,
    response?: CallableResponse<AiSearchStream>,
) => Promise<AiSearchResponse>;
